import { endClinicImpersonation } from '@pa/api/clinic'
import type { ImpersonationController } from './controller'

/**
 * Ends the stored session with #36 (Frontend §6.4 step 6): best effort, `impersonation_ended` or a failure counts as
 * done (the session also ends at its 60-minute limit). The state is cleared first and the id sent explicitly, so a
 * sign-out triggered by this very call can't call it again.
 */
export async function endImpersonation(
  controller: ImpersonationController,
  reason: 'exit' | 'sign_out',
): Promise<void> {
  const state = controller.current()
  if (!state) return
  controller.clear()
  try {
    await endClinicImpersonation({ reason }, { headers: { 'X-Impersonation-Id': state.id } })
  } catch {
    // best effort
  }
}

/** Exit (§4.4 banner): end it, then back to the clinic's S-04 on the admin site with "Impersonation ended". */
export async function exitImpersonation(controller: ImpersonationController, adminOrigin: string): Promise<void> {
  const href = controller.adminReturnHref() ?? `${adminOrigin}/clinics`
  await endImpersonation(controller, 'exit')
  controller.assign(href)
}
